<template>
	<div class="Team">
		<div class="flex item-center">
			<!-- <div class="flex item-center"> -->
				<div class="font-semibold text-lg pt-5 pb-2">
				Team Details
				</div>
				<div v-if="storeName != ''" class="m-4">
					<BaseButton
						:disabled="storeName == ''"
						style="width: 100px;"
						buttonclass="btn p-2 text-xs "
						@click="createNewEmployee()"
					>
						Add New
					</BaseButton>
				</div>
				<div v-if="storeName != ''" class="my-4 ml-1 mr-5">
					<BaseButton
						:disabled="true"
						style="width: 100px;"
						buttonclass="btn p-2 text-xs "
						@click="user_csv_upload_popup = !user_csv_upload_popup"
					>
						Upload CSV
					</BaseButton>
				</div>
				<div class="mt-3" style="width:40%;">
					<el-input
						v-model="search"
						placeholder="Search By Employee Name"
						prefix-icon="el-icon-search"
						@input="searchName()"
						>
					</el-input>

				</div>
			<!-- </div> -->
		</div>
		<div class="section1 page-body">

			<div v-if="storeName != ''" v-loading="is_emp_list_loading">
				<baseAddEmployeeTable
					:planning-shift-day-list="planning_shift_day_list"
					:functions="functions"
					:store-name="storeName"
					:selected-store="selected_store"
					:employe-details="employeDetails"
					:department-list="departmentList"
					:filter-department-list="filterDepartmentList"
					:filter-functions-list="filterFunctionsList"
					:filter-designation-list="filterDesignationList"
					:archived-amploye-details="archivedAmployeDetails"
					:designation-list="designationList"
					:shifts-list="shifts"
					:secondary-stores="secondary_stores"
					@staffOpenPopUp="staffOpenPopUp"
					@addNewStaff="addNewStaff"
					@openEditEmployeePopup="openEditEmployeePopup"
					@getStaffDataDetails="getStaffDataDetails"
					@disable_team_actions="disableTeamActions"
					@beforeChangeTab="beforeChangeTab"
				></baseAddEmployeeTable>
			</div>
		</div>

		 <!-- <div>
			<el-row class="card text-right my-2 border-top-btn-sec" :gutter="20">
            <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
              <div  style="width: 6rem; float: right">
                <BaseButton buttonclass="btn p-2 text-sm orng-btn"
                 :disabled="storeName == '' || disable_team_action" @click="addNewStaff">
                  Save
                </BaseButton>
              </div>
            </el-col>
          </el-row>
		</div> -->

		<el-dialog title="Please confirm !" :visible.sync="isShowPopUp" width="40%">
			<span>Are you sure you want to continue without saving changes?</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowPopUp = false">No</el-button>
				<el-button type="warning" size="mini" @click="changeUrl">Yes</el-button>
			</span>
		</el-dialog>

		<el-dialog
			:title="'Edit' + ' ' + employee"
			:close-on-click-modal="true"
			width="60%"
			:lock-scroll="true"
			:show-close="true"
			:visible.sync="showEditEmployeePopup"
		>
			<staffEmployeePopup
				:key="editComponentKey"
				:full-time-min="full_time_min"
				:part-time-min="part_time_min"
				:full-time-hours="full_time_hours"
				:part-time-hours="part_time_hours"
				:store-designation-list="designationList"
				:full-time-weekly-off="full_time_weekly_off"
				:part-time-weekly-off="part_time_weekly_off"
				:show-add-employee-popup="showEditEmployeePopup"
				:planning-shift-day-list="planning_shift_day_list"
				:functions="functions"
				:shifts="shifts"
				:department-list="departmentList"
				:designation-list="designationList"
				:store-list="store_list"
				:employee-data="employeeData"
				:employee-list="employeDetails"
				:employee-index="employeeIndex"
				:store-name="storeName"
				:store-details="store_details"
				:secondary-stores="secondary_stores"
				@closeEditEmployeePopup="showEditEmployeePopup = false"
				@closedPopup="closedPopup"
				@staffOpenPopUp="staffOpenPopUp"
				@callSaveAPI="callSaveAPI"
			/>
		</el-dialog>

		<el-dialog title="Add new employee" :visible.sync="showAddEmployeePopup">
			<staffEmployeePopup
				:key="addComponentKey"
				:full-time-min="full_time_min"
				:store-designation-list="designationList"
				:part-time-min="part_time_min"
				:full-time-hours="full_time_hours"
				:part-time-hours="part_time_hours"
				:full-time-weekly-off="full_time_weekly_off"
				:part-time-weekly-off="part_time_weekly_off"
				:planning-shift-day-list="planning_shift_day_list"
				:show-add-employee-popup="showAddEmployeePopup"
				:functions="functions"
				:shifts="shifts"
				:store-list="store_list"
				:department-list="departmentList"
				:designation-list="designationList"
				:employee-list="employeDetails"
				:new-employee-data="newEmployeeData"
				:employee-index="employeDetails.length"
				:store-name="storeName"
				:store-details="store_details"
				:secondary-stores="secondary_stores"
				@closeEditEmployeePopup="showAddEmployeePopup = false"
				@closedPopup="closedPopup"
				@staffOpenPopUp="staffOpenPopUp"
				@callSaveAPI="callSaveAPI"
			/>
		</el-dialog>

		 <!-- Dialog for USER CSV File Upload -->
		 <el-dialog title="Upload CSV" :visible.sync="user_csv_upload_popup" width="40%" class="shift-pref-csv-upload">
            <div class="flex items-center justify-between pt-3 pb-5 mb-4" style="border-bottom: 1px solid #dddddd;">
                <h2 style="color: black; font-weight: 700; font-size: 20px;" >Upload Users</h2>
                <i class="el-icon-circle-close cursor-pointer" style="color: black; font-size: 24px;" @click="user_csv_upload_popup = false"></i>
            </div>
            <!-- Sample File -->
            <a slot="footer" href="/files/location_upload_template.csv" download style="width: 120px; "
                class="no-underline text-white text-sm bg-amplitude p-2">
                <i class="el-icon-download"></i> CSV Template
            </a>
            <div class="flex flex-col items-center">
                <el-upload ref="upload" class="upload-demo" drag :auto-upload="false" :limit="1" :on-exceed="fileLimitExceed"
                    :on-change="getUploadFile" :on-remove="fileRemoved">
                    <img style="width: 125px; margin: 15px 0" src="../../../../../assets/images/upload_csv.svg" alt="upload-csv-file"
                        srcset="">
                    <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                    <div slot="tip" class="el-upload__tip">Upload CSV File Only</div>
                </el-upload>

                <el-progress class="mt-5" color="#f28b4d" type="circle" :percentage="uploadPercentage"></el-progress>

                <BaseButton :disabled="!proceedUpload" style="margin-top: 20px; width: auto;"
                    buttonclass="btn p-2 text-sm orng-btn" @click="uploadCsv(uploadedFile)">
                    <i class="el-icon-upload2"></i> Upload CSV
                </BaseButton>
            </div>
        </el-dialog>

	</div>
</template>
<script>
import baseAddEmployeeTable from "../../../../../components/admin/labourPlaninig/storeSettings/staff/baseAddEmployeeTable/baseAddEmployeeTable.vue";
import { mapState } from "vuex";
import _ from "lodash";
import LabourPalnningService from "../../../../../services/labourPalnningService";
import csvService from "../../../../../services/csvService";
import { EventBus } from "../../../../../eventBus";
import moment from "moment";
import staffEmployeePopup from "../../storeSettings/staff/staffEmployeePopup/staffEmployeePopup";
import { forEach } from 'lodash';
export default {
	name: "Store Teams",
	components: {
		baseAddEmployeeTable,
		staffEmployeePopup
	},
	data() {
		return {
			search: "",
			part_timers_follow_fixed_hours: "yes",
			partialAllowed: "no",
			changeKeys: false,
			isShowPopUp: false,
			isRouteChanged: false,
			path: "",
			min_staff_in_business_hours: null,
			min_staff_in_preopening_hours: null,
			min_staff_in_postclosing_hours: null,
			Store_Closed_On: "",
			store_hours: "",
			store_name: "",
			total_break_time: "",
			break_time: "",
			part_time: "",
			full_time: "",
			shift_type: "",
			female_start_time: "",
			female_end_time: "",
			shift_list: "",
			staff_weekly_off: "",
			no_of_breaks_a_day: "0",
			employee_type: "",
			planning_shift_day: null,
			full_time_weekly_off: "",
			part_time_weekly_off: "",
			select_type_list: "",
			staff_weekly_off_list: [0, 1, 2, 3, 4, 5, 6],
			number_of_breaks_day_list: [0, 1, 2, 3, 4, 5],
			store_list: [],
			select_shift_list: [],
			total_break_hour: "",
			total_break_min: "",
			full_time_hours: "",
			full_time_min: "",
			part_time_hours: "",
			part_time_min: "",
			total_break_interval_hour: "",
			total_break_interval_min: "",
			total_break_interval_time: "",
			pt_break_duration: "",
			ft_break_duration: "",
			ft_total_break_interval_time: "",
			pt_total_break_interval_time: "",
			ft_total_breaks: "",
			pt_total_breaks: "",
			shifts: [],
			StaffDetails: {},
			planning_shift_day_list: [],
			download_url: {},
			url: "",
			employeDetails: [],
			archivedAmployeDetails: [],
			filterEmployeDetails: [],
			filterArchivedAmployeDetails: [],
			departmentList: [],
			functions: [],
			ft_total_break_time: [],
			pt_total_break_time: [],
			showEditEmployeePopup: false,
			employeeData: {},
			employeeIndex: null,
			editComponentKey: 0,
			addComponentKey: 0,
			showAddEmployeePopup: false,
			newEmployeeData: {},
			employee: "",
			store_details: {},
			is_emp_list_loading: false,
			designationList: [],
			filterDepartmentList: [],
			filterFunctionsList: [],
			filterDesignationList: [],
			selected_store: '',
			user_csv_upload_popup: false,
			proceedUpload: false,
			disable_team_action: false,
            uploadedFile: {},
            uploadPercentage: 0,
			secondary_stores: [],
		};
	},
	computed: {
		...mapState("LabourPlanning", ["storeName"]),
		checkCompany(){
			let data = localStorage.getItem('check_company');
			return JSON.parse(data);
		}
	},
	created: async function() {
        await this.getStoreList();
        await this.getStaffDataDetails();
        await this.getDepartmentList();
        await this.getStoreDetails();
       if(this.checkCompany.is_sb_malaysia){
			await this.getSecondaryStores();
		}
        await LabourPalnningService.getStoreClosedOnDropdown().then(response => {
            this.planning_shift_day_list = JSON.parse(response.data);
            this.planning_shift_day_list.splice(0, 1);
        });
    },
	mounted() {
		EventBus.$on("updateStoreData", data =>{
			this.getStaffDataDetails();
			this.getDepartmentList();
			this.getStoreDetails();
			// this.getDesignation();
		});
		EventBus.$on("toggleTeamSection", data =>{
			 this.search = "";
		});
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		callSaveAPI(condition){
			this.addNewStaff();
			// this.$emit('callTeamSaveAPI', condition)
		},
		beforeChangeTab(condition){
			this.$emit('beforeChangeTab', condition)
		},
		disableTeamActions(action){
                this.disable_team_action = action;
        },
		uploadShiftPreferenceCSV(){
                this.csv_upload_popup = true;
        },
        getUploadFile(file, fileList) {
            if (file) {
                this.uploadedFile = file;
                console.log(file.raw.type);
                if (file.raw.type !== 'text/csv') {
                    this.$notify.error({
                        title: 'Error',
                        message: 'This file is not supported! Please upload CSV file only'
                    });
                    this.$refs.upload.clearFiles()
                    return;
                }
            }
            this.uploadedFile ? this.proceedUpload = true : false;
        },
        fileRemoved(file, fileList) {
            this.proceedUpload = false;
        },
        fileLimitExceed(file, fileList) {
            this.$notify.error({
                title: 'Error',
                message: 'File limit is exceed! Please remove older file first'
            })
        },
        uploadCsv(file) {
            // console.log(file);
            var formData = new FormData();
            formData.append("file", file.raw);
            this.proceedUpload = false;
            fileServerAddr.post(`/outlet/locations/upload/with/csv/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        this.uploadPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    }
                }
            }).then((response) => {
                this.uploadingIsDone();
                this.getAllShiftPreferenceData();
                this.$notify.success({
                    title: 'Uploaded',
                    message: 'File successfully uploaded'
                });
            }).catch((err) => {
                const error = JSON.parse(err.response.data);
                this.uploadingIsDone();
                this.$notify.error({
                    title: 'Uploading fail',
                    message: `${error.msg}`
                });
                console.error(err);
            });
        },
        uploadingIsDone(succ) {
            if (succ) {
                setTimeout(() => {
                    this.uploadCSVDialog = false;
                }, 1000);
            }
            this.proceedUpload = true;
            this.uploadedFile = {};
            this.uploadPercentage = 0;
            this.$refs.upload.clearFiles();
        },
		searchName() {
			if(this.search) {
				this.employeDetails = this.filterEmployeDetails.filter(data => data.full_name.toLowerCase().includes(this.search.toLowerCase()))
				this.archivedAmployeDetails = this.filterArchivedAmployeDetails.filter(data => data.full_name.toLowerCase().includes(this.search.toLowerCase()))
			} else {
				this.employeDetails = this.filterEmployeDetails;
				this.archivedAmployeDetails = this.filterArchivedAmployeDetails;
			}
		},
		clearValue() {
			if (this.part_timers_follow_fixed_hours == "no") {
				this.part_time_hours = "0";
				this.part_time_min = "0";
			}
		},

		setSeconds(value) {
			if (value.toString().length == 1) {
				return "0" + value;
			}
			return value;
		},

		closedPopup() {
			this.showEditEmployeePopup = false;
			this.showAddEmployeePopup = false;
		},

		getAllShift() {
			let params = {
				outlet_id: localStorage.getItem('store') ? localStorage.getItem('store') : this.storeName,
			};

			return LabourPalnningService.getShiftForStoreDetails(params)
			.then(response => {
				return response;
			})
			.catch(error => {
				console.log("error", error);
			});
			// /read/store-shifts/
		},

		getSecondaryStores() {
			let params = {
				outlet: localStorage.getItem('store') ? localStorage.getItem('store') : this.storeName,
			};

			LabourPalnningService.getClusterForOutlet(params)
			.then(response => {
				let all_stores = JSON.parse(response.data);
				console.log(all_stores, 'all_stores')
				if(all_stores.length){
					this.secondary_stores =  all_stores[0].outlets;
				}
			})
			.catch(error => {
				console.log("error", error);
			});
			// /read/store-shifts/
		},

		// api to get store list
		getStoreList() {
			LabourPalnningService.getAllStoreData()
				.then(response => {
					this.store_list = JSON.parse(response.data);

					this.store_list.forEach((str)=>{
						if(str.id == this.storeName){
							this.selected_store = str.name;
						}
						// Secondary Stores
						if(!this.checkCompany.is_sb_malaysia){
							this.secondary_stores = this.store_list;
						}
					})
				})
				.catch(err => {
					console.log(err);
				});
		},

		// api to get department list
		getDepartmentList() {
			let params = {
				outlet_id: this.storeName
			};
			LabourPalnningService.getDepartment(params)
				.then(response => {
					this.departmentList = JSON.parse(response.data);
					console.log(JSON.parse(response.data), 'JSON.parse(response.data)')
					// this.filterDepartmentList = this.departmentList.map(e=> {
					// 	return {
					// 		text: e.department,
					// 		value: e.id
					// 	}
					// });
				})
				.catch(err => {
					console.error(err);
				});
		},

		// api to get Designation list
		getDesignation() {
			let params = {
				store: this.storeName
			};
			LabourPalnningService.getDesignation(params)
				.then(response => {
					this.designationList = JSON.parse(response.data);

					this.$store.commit('commitDesignationsList', this.designationList);

					// console.log('employeDetails', this.employeDetails);

					let temp = [];

					this.employeDetails.forEach(e =>{
						if(Object.keys(e.designation_info).length){
							let obj = {
								text: e.designation_info.name,
								value: e.designation_info.id,
							}

							this.$set(e, 'designation', e.designation_info.id)

							temp.push(obj);
						}
					})

					this.filterDesignationList = _.uniqBy(temp, 'value');

					// console.log('this.filterDesignationList', this.filterDesignationList);

					// var commonDesignation = _.uniqBy(this.employeDetails, "designation");

					// let designation = [];

					// for(let i in commonDesignation) {
					// 	for(let j in this.designationList) {
					// 		if(this.designationList[j].id == commonDesignation[i].designation) {
					// 			designation.push(this.designationList[j])
					// 		}
					// 	}

					// }

					// this.filterDesignationList = designation.map(e=> {
					// 	return {
					// 		text: e.name,
					// 		value: e.id
					// 	}
					// });

				})
				.catch(err => {
					console.log(err);
				});
		},

		getStaffDataDetails() {
			if (this.storeName) {
				// this.getDepartmentList();
				this.store_list.forEach((str)=>{
					if(str.id == this.storeName){
						this.selected_store = str.name;
					}
				})
				this.is_emp_list_loading = true;		//enabled loader
				this.employeDetails = [];

				var params = {
					outlet_id: this.storeName
				};
				LabourPalnningService.getStaffDetails(params)
					.then(async response => {
						let function_res = await this.getEmployeeFunctions();

						if(function_res.status == 200){
							this.manageEmployeeFunctions(function_res);
						}

						let shift_res = await this.getAllShift();

						if(shift_res.status == 200){
							this.shifts = JSON.parse(shift_res.data);

							// console.log(JSON.parse(shift_res.data))
						}

						let empl_list_res = await this.getEmployeeList();

						if(empl_list_res.status == 200){
							this.manageEmployeeList(empl_list_res);
							// console.log(this.employeDetails);
						}

						this.StaffDetails = JSON.parse(response.data);
						// if (this.StaffDetails) {
							// if (this.StaffDetails.shifts.length) {
							// 	this.getShiftList(this.StaffDetails.shifts);
							// }

						this.partialAllowed = this.StaffDetails.partial_shifts;
						this.min_staff_in_business_hours = this.StaffDetails.min_staff_in_business_hours;
						this.min_staff_in_postclosing_hours = this.StaffDetails.min_staff_in_postclosing_hours;
						this.min_staff_in_preopening_hours = this.StaffDetails.min_staff_in_preopening_hours;
						this.staff_weekly_off = this.StaffDetails.staff_weekly_off;
						this.shift_type = this.StaffDetails.shift_type;
						this.no_of_breaks_a_day = this.StaffDetails.no_of_breaks_a_day;
						this.planning_shift_day = Number(this.StaffDetails.planning_shift_day);
						this.part_time_weekly_off = this.StaffDetails.part_time_weekly_off;
						this.full_time_weekly_off = this.StaffDetails.full_time_weekly_off;
						this.part_timers_follow_fixed_hours = this.StaffDetails.part_timers_follow_fixed_hours;
						// this.partialAllowed = this.StaffDetails.partial_shifts;
						// this.female_start_time = this.StaffDetails.female_start_time;
						// this.female_end_time = this.StaffDetails.female_end_time;
						// this.ft_break_interval = this.StaffDetails.ft_total_break_interval_time;
						// this.pt_break_interval = this.StaffDetails.pt_total_break_interval_time;
						this.ft_total_break = this.StaffDetails.ft_total_breaks;
						this.pt_total_break = this.StaffDetails.pt_total_breaks;

						this.pt_total_break_interval_time = this.StaffDetails.pt_total_break_interval_time;
						this.ft_total_break_interval_time = this.StaffDetails.ft_total_break_interval_time;

						this.ft_total_breaks = this.StaffDetails.ft_total_breaks;
						this.pt_total_breaks = this.StaffDetails.pt_total_breaks;

						// this.pt_break_duration = this.StaffDetails.pt_break_duration;
						// this.ft_break_duration = this.StaffDetails.pt_break_duration;
						// this.changePtBreakDuration();
						// this.changeFtBreakDuration();
						if (this.StaffDetails.female_start_time.length > 5) {
							this.female_start_time = this.StaffDetails.female_start_time.substring(0, this.StaffDetails.female_start_time.length - 6);
						}
						if (this.StaffDetails.female_end_time.length > 5) {
							this.female_end_time = this.StaffDetails.female_end_time.substring(0, this.StaffDetails.female_end_time.length - 6);
						}
						this.full_time = this.StaffDetails.full_time_duration_day_min;
						[this.full_time_hours, this.full_time_min] = this.full_time.split(
							":"
						);
						if (this.StaffDetails.part_timers_follow_fixed_hours == "no") {
							this.part_time = "00:00";
						} else {
							this.part_time = this.StaffDetails.part_time_duration_day_min;
						}
						[this.part_time_hours, this.part_time_min] = this.part_time.split(
							":"
						);
						this.part_time = this.StaffDetails.part_time_duration_day_min;

						this.ft_total_break_time = this.StaffDetails.ft_total_break_time;
						this.pt_total_break_time = this.StaffDetails.pt_total_break_time;

						this.is_emp_list_loading = false;		//disabled loader


							// if (this.StaffDetails.employees.length) {
							// }
						// } else {
						// 	this.is_emp_list_loading = false;		//disabled loader
						// 	this.employeDetails = [];
						// 	this.shifts = [
						// 		{
						// 			min_staff_required: null,
						// 			shift_end_time: null,
						// 			shift_name: "",
						// 			shift_start_time: null
						// 		}
						// 	];
						// 	this.min_staff_in_business_hours = "";
						// 	this.min_staff_in_postclosing_hours = "";
						// 	this.min_staff_in_preopening_hours = "";
						// 	this.staff_weekly_off = "";
						// 	this.shift_type = "";
						// 	this.no_of_breaks_a_day = "";
						// 	this.planning_shift_day = "";
						// 	this.part_time_weekly_off = "";
						// 	this.full_time_weekly_off = "";
						// }
					})
					.catch(error => {
						console.log("error", error);
						this.is_emp_list_loading = false;		//disabled loader
					});
			}
		},

		manageEmployeeFunctions(function_res){
			this.functions = JSON.parse(function_res.data);

			var commonDepartMents = _.uniqBy(this.functions, "store_department");
			let department = [];

			for(let i in commonDepartMents) {
				for(let j in this.departmentList) {
					if(this.departmentList[j].id == commonDepartMents[i].store_department) {
						department.push(this.departmentList[j])
					}
				}

			}

			// this.departmentList = department;

			this.filterDepartmentList = department.map(e=> {
				return {
					text: e.department,
					value: e.id
				}
			});

			this.filterFunctionsList = this.functions.map(e=> {
				return {
					text: e.function,
					value: e.id
				}
			});
		},

		manageEmployeeList(response){
			let employeeList = JSON.parse(response.data);

			for (var i = 0; i < employeeList.length; i++) {
				let arr = [];
				if (employeeList[i].secondary_functions.length) {
					for (let f = 0; f < employeeList[i].secondary_functions.length; f++) {
						arr.push(employeeList[i].secondary_functions[f].id);
					}
				}

				// console.log('arr ===', arr);
				employeeList[i].secondary_functions = arr;

				let storeArr = [];
				// Urgent fix (Need to debug the issue for SBMY)
				// if (employeeList[i].secondary_stores.length) {
				// 	for (let store = 0; store < employeeList[i].secondary_stores.length; store++) {
				// 		console.log(employeeList[i].secondary_stores, 'employeeList[i].secondary_stores[store].id', typeof employeeList[i].secondary_stores);
				// 		storeArr.push(employeeList[i].secondary_stores);
				// 	}
				// }

				// employeeList[i].secondary_stores = storeArr;

				// var temp = [];
				// for (var j = 0; j < employeeList[i].weekly_offs.length; j++) {
				// 	temp.push(employeeList[i].weekly_offs[j].id);
				// }

				if (employeeList[i].prefer_start_time) {
					if (employeeList[i].prefer_start_time.length > 5) {
						employeeList[i].prefer_start_time = employeeList[i].prefer_start_time.substring(0, employeeList[i].prefer_start_time.length - 3);
					}
				}

				if (employeeList[i].prefer_end_time) {
					if (employeeList[i].prefer_end_time.length > 5) {
						employeeList[i].prefer_end_time = employeeList[i].prefer_end_time.substring(0, employeeList[i].prefer_end_time.length - 3);
					}
				}

				// employeeList[i].weekly_offs = temp;

				employeeList[i].paytype = employeeList[i].paytype ? employeeList[i].paytype : {
					daily_weekday_rate: 0,
					daily_weekend_rate:  0,
					hourly_weekday_rate: 0,
					hourly_weekend_rate: 0,
					monthly_rate: 0,
					pay_type: "",
					weekly_rate: 0,
				};
			}

			this.employeDetails = employeeList.filter(el => {
				if(!el.archived) {
					return el;
				}
			});

			this.archivedAmployeDetails = employeeList.filter(el => {
				if(el.archived) {
					return el;
				}
			});

			this.filterArchivedAmployeDetails = this.archivedAmployeDetails;
			this.filterEmployeDetails = this.employeDetails;
			this.getDesignation();
		},

		// api to employee details
		getEmployeeList() {
			let obj = {
				outlet_id : this.storeName
			};

			return LabourPalnningService.getAllEmployeeListNetworkCallBack(obj)
			.then(response => {
				return response;
			})
			.catch(err => {
				console.log(err);
			});
		},

		// getShiftList(ShiftList) {
		// 	for (var i = 0; i < ShiftList.length; i++) {
		// 		if (ShiftList[i].shift_start_time.length > 5) {
		// 			ShiftList[i].shift_start_time = ShiftList[
		// 				i
		// 			].shift_start_time.substring(
		// 				0,
		// 				ShiftList[i].shift_start_time.length - 6
		// 			);
		// 		}
		// 		if (ShiftList[i].shift_end_time.length > 5) {
		// 			ShiftList[i].shift_end_time = ShiftList[i].shift_end_time.substring(
		// 				0,
		// 				ShiftList[i].shift_end_time.length - 6
		// 			);
		// 		}
		// 	}
		// 	this.shifts = ShiftList;
		// },

		addStaffEmpList() {
			this.employeDetails.push({
				// first_name: "",
				// last_name: "",
				full_name: "",
				gender: "",
				employee_type: "",
				hrs: "",
				mins: "",
				email: "",
				phone: "",
				employee_id: ""
			});
		},

		setTotalHrs(type) {
			if (type === "Full Time") {
				return this.full_time;
			} else {
				return this.part_time;
			}
		},

		// getEmployeeList(employeeList) {
		// 	for (var i = 0; i < employeeList.length; i++) {
		// 		let arr = [];

		// 		if (employeeList[i].secondary_functions.length) {
		// 			for (let f = 0; f < employeeList[i].secondary_functions.length; f++) {
		// 				arr.push(employeeList[i].secondary_functions[f].id);
		// 			}
		// 		}
		// 		employeeList[i].secondary_functions = arr;
		// 		let storeArr = [];

		// 		if (employeeList[i].secondary_stores.length) {
		// 			for (let store = 0; store < employeeList[i].secondary_stores.length; store++) {
		// 				storeArr.push(employeeList[i].secondary_stores[store].id);
		// 			}
		// 		}

		// 		employeeList[i].secondary_stores = storeArr;
		// 		var temp = [];

		// 		for (var j = 0; j < employeeList[i].weekly_offs.length; j++) {
		// 			temp.push(employeeList[i].weekly_offs[j].id);
		// 		}

		// 		if (employeeList[i].prefer_start_time) {
		// 			if (employeeList[i].prefer_start_time.length > 5) {
		// 				employeeList[i].prefer_start_time = employeeList[i].prefer_start_time.substring(0, employeeList[i].prefer_start_time.length - 3);
		// 			}
		// 		}

		// 		if (employeeList[i].prefer_end_time) {
		// 			if (employeeList[i].prefer_end_time.length > 5) {
		// 				employeeList[i].prefer_end_time = employeeList[i].prefer_end_time.substring(0, employeeList[i].prefer_end_time.length - 3);
		// 			}
		// 		}

		// 		// employeeList[i].duration = this.setTotalHrs(employeeList[i].employee_type);

		// 		// if (employeeList[i].employee_type == "Part Time" && employeeList[i].duration == "00:00") {
		// 		// 	employeeList[i].duration = "";
		// 		// }
		// 		employeeList[i].weekly_offs = temp;
		// 		employeeList[i].paytype = employeeList[i].paytype ? employeeList[i].paytype : {
		// 			daily_weekday_rate: 0,
		// 			daily_weekend_rate:  0,
		// 			hourly_weekday_rate: 0,
		// 			hourly_weekend_rate: 0,
		// 			monthly_rate: 0,
		// 			pay_type: "",
		// 			weekly_rate: 0,
		// 		};
		// 	}
		// 	this.employeDetails = employeeList.filter(el => {
		// 		if(!el.archived) {
		// 			return el;
		// 		}
		// 	});
		// 	this.archivedAmployeDetails = employeeList.filter(el => {
		// 		if(el.archived) {
		// 			return el;
		// 		}
		// 	});
		// 	this.filterArchivedAmployeDetails = this.archivedAmployeDetails;
		// 	this.filterEmployeDetails = this.employeDetails;
		// 	this.getDesignation();
		// 	// console.log(this.employeDetails);
		// },

		deleteEmp(id, index) {
			this.employeDetails.splice(index, 1);
			var data = {
				id: id
			};
		},

		uploadCSV() {
			var file = event.target.files[0];
			// console.log(file);
			var formData = new FormData();
			formData.append("Upload-Employee.csv", file);
			formData.append("outelet_id", this.storeName);
			csvService.staffCsvFileUpload(formData);
		},


		async addNewStaff() {
			let empList = this.employeDetails;

			console.log(empList);

			for (var i = 0; i < empList.length; i++) {
				empList[i].email = empList[i].email ? empList[i].email.toLowerCase() : empList[i].email;
				// empList[i].store = this.storeName;
				// empList[i].store_name = this.storeName;
				// shift_type is flexible then fixed_shift_preferances should be blank
				if(this.store_details.shift_type == 'flexible'){
					if (empList[i].prefer_start_date) {
						empList[i].prefer_start_date = `${moment(new Date(empList[i].prefer_start_date)).format("YYYY-MM-DD")}`;
					}

					if (empList[i].prefer_end_date) {
						empList[i].prefer_end_date = `${moment(new Date(empList[i].prefer_end_date)).format("YYYY-MM-DD")}`;
					}

					empList[i].fixed_shift_preferances = [];
				}else if(this.store_details.shift_type == 'fixed'){
					// shift_type is fixed then prefer start,end time prefer start,end date should be blank

					empList[i].prefer_start_date = null;
					empList[i].prefer_end_date = null;

					empList[i].prefer_start_time = null;
					empList[i].prefer_end_time = null;
				}

				if (empList[i].weekly_off_end_date) {
					empList[i].weekly_off_end_date = `${moment(new Date(empList[i].weekly_off_end_date)).format("YYYY-MM-DD")}`;
				}
				if (empList[i].weekly_off_start_date) {
					empList[i].weekly_off_start_date = `${moment(new Date(empList[i].weekly_off_start_date)).format("YYYY-MM-DD")}`;
				}

				// let storeArr = [];
				// if (empList[i].secondary_stores.length) {
				// 	for (let store = 0; store < empList[i].secondary_stores.length; store++) {
				// 		let obj = {
				// 			id: empList[i].secondary_stores[store]
				// 		};
				// 		storeArr.push(obj);
				// 	}
				// }
				// empList[i].secondary_stores = storeArr;

				let arr = [];
				if (empList[i].secondary_functions && empList[i].secondary_functions.length) {
					for (let f = 0; f < empList[i].secondary_functions.length; f++) {
						let obj = {
							id: empList[i].secondary_functions[f]
						};
						arr.push(obj);
					}
				}

				// if(empList[i].designation){
				// 	empList[i].designation = empList[i].designation_info.id
				// }

				empList[i].secondary_functions = arr;
				empList[i].prefer_weekly_off = empList[i].weekly_offs;
				empList[i].duration = empList[i].duration == "" ? "00:00" : empList[i].duration;
			}

			var params = {
				outlet_id: this.storeName,
				employees: empList
			};

			LabourPalnningService.addEmployees(params)
				.then(response => {
					if (response.status === 200) {
						this.isRouteChanged = true;
						this.$notify.success({
							title: "Success",
							message: "Team Updated Succesfully"
						});
						this.getStaffDataDetails();
						this.changeKeys = true;
						this.closedPopup();
					}
				})
				.catch(err => {
					console.log(err);
				});
		},

		getEmployeeFunctions() {
			var params = {
				outlet_id: this.storeName
			};
			return LabourPalnningService.getWorkArea(params)
			.then(response => {
				return response;
				// console.log("commonDepartMents", commonDepartMents);
			});
		},

		changeUrl() {
			this.isRouteChanged = true;
			this.isShowPopUp = false;
			this.$router.push({ path: this.path }).catch(()=>{});
		},

		staffOpenPopUp() {
			// use for chnaged any key and displayed popup
			// comman function

			this.changeKeys = true;
		},

		chnageFemalePreferTime() {
			// changed prefet time for femail emp
			this.changeKeys = true;
			for (var i in this.employeDetails) {
				if (this.employeDetails[i].gender == "Female") {
					this.employeDetails[i].prefer_start_time = this.female_start_time;
					this.employeDetails[i].prefer_end_time = this.female_end_time;
					// console.log("this.employeDetails[i]", this.employeDetails[i]);
				}
			}
		},

		changePtBreakDuration() {
			this.pt_total_break_time = [];
			for (var i = 0; i < Number(this.pt_total_breaks); i++) {
				this.pt_total_break_time.push({
					pt_total_break_hour: "",
					pt_total_break_min: ""
				});
			}
		},

		changeFtBreakDuration() {
			this.ft_total_break_time = [];
			for (var i = 0; i < Number(this.ft_total_breaks); i++) {
				this.ft_total_break_time.push({
					ft_total_break_hour: "",
					ft_total_break_min: ""
				});
			}
		},

		openEditEmployeePopup(employee_data, index, id) {
			this.editComponentKey += 1; //You take this strategy of assigning keys to children, but whenever you want to re-render a component, you just update the key.
			this.showEditEmployeePopup = true;
			this.employee = employee_data.full_name;
			// if (employee_data.gender === "Female") {
			// 	// changed prefrred time of female employee
			// 	employee_data.prefer_start_time = this.female_start_time;
			// 	employee_data.prefer_end_time = this.female_end_time;
			// }
			this.employeeIndex = id;
			this.employeeData = JSON.parse(JSON.stringify(employee_data));

			if(!this.employeeData.duration){
				if (employee_data.employee_type === "Full Time") {
					this.employeeData.duration = this.full_time_hours + ":" + this.full_time_min;
				} else {
					this.employeeData.duration = this.part_time_hours + ":" + this.part_time_min;
				}
			}else{
				this.employeeData.duration = this.employeeData.duration.slice(0, 5);
			}

			console.log(this.employeeData);
		},

		createNewEmployee() {
			this.addComponentKey += 1; //You take this strategy of assigning keys to children, but whenever you want to re-render a component, you just update the key.
			this.newEmployeeData = {
				full_name: "",
				gender: "",
				primary_role: "",
				secondary_role: [],
				secondary_store: [],
				designation: '',
				department: "",
				status: "",
				employee_type: "",
				duration: "",
				function: null,
				prefer_start_time: null,
				prefer_end_time: null,
				prefer_start_date: null,
				prefer_end_date: null,
				weekly_off_start_date: null,
				weekly_off_end_date: null,
				weekly_offs: [],
				prefer_start_date: null,
				prefer_end_date: null,
				shift_preference: "",
				email: null,
				phone: null,
				selectedID: "",
				selectedEmployeeIndex: "",
				pay_type: null,
				paytype : {
					daily_weekday_rate: 0,
					daily_weekend_rate:  0,
					hourly_weekday_rate: 0,
					hourly_weekend_rate: 0,
					monthly_rate: 0,
					pay_type: "",
					weekly_rate: 0,
				},
				pay_rate: null,
				week_days_rate: null,
				week_ends_rate: null,
				weekly_rate: null,
				monthly_rate: null,
			};
			this.showAddEmployeePopup = true;
		},

		// api to get store details
		getStoreDetails() {
			let obj = {
				outlet_id : this.storeName
			};

			LabourPalnningService.getAutoStoreDetails(obj)
			.then(response => {
				if(response.status){
					this.store_details = JSON.parse(response.data);
					// this.store_details.shift_type = 'fixed';
				}
			})
			.catch(err => {
				console.error(err);
			});
		},
	},

	beforeRouteLeave(to, from, next) {
		if (
			this.changeKeys
			// this.shift_type != "" ||
			// this.full_time_weekly_off != "" ||
			// this.part_time_weekly_off != "" ||
			// this.no_of_breaks_a_day != "" ||
			// this.planning_shift_day != ""
		) {
			this.isShowPopUp = true;
		} else {
			this.isRouteChanged = true;
		}
		this.path = to.path;
		// this.isShowPopUp = true;
		// console.log(this.isRouteChanged);
		if (this.isRouteChanged) {
			next();
		} else {
			next(false);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../storeSettings/staff/Staff.scss";
.Team {
	padding: 1rem 2rem;
	background: #fff;
	border-radius: 12px !important;
	box-shadow: 0 0 1px rgba(255, 255, 255, .5) !important;
	.page-body {
		height: 60vh;
		overflow-y: scroll;
		overflow-x: hidden;
	}
}
</style>
<style>
th.is-leaf {
	background-color: #f2f2f2;
	text-transform: uppercase;
	word-break: break-word;
}
/* .Team .el-dialog {
	width: 70%;
	margin-top: 50px !important;
}
.Team .el-dialog__header {
	background: #2e323a;
	color: #ffffff;
	padding: 15px;
}
.Team .el-dialog__title {
	color: #ffffff;
} */

.el-dialog.custom-class {
	position: absolute;
	right: 0;
	margin: 0;
	top: 0;
	margin-top: 0 !important;
}
.border-top-btn-sec{
  padding-top: 15px;
  border-top: 1px solid #dae1e7;
}
</style>
